module.exports = __webpack_public_path__ + "static/media/embassy_letter.19405392.svg";